<div class="input-group d-inline-flex align-items-center" [ngClass]="{ 'multiline-text': modelType !== 'TextModel' }">
    @if (modelType === 'TextModel') {
        <input
            type="text"
            #textInput
            [formControl]="textInputControl"
            [placeholder]="model.options.placeholder"
            [attr.inputmode]="inputMode || model.options.inputType"
            (blur)="onBlur()"
            (focus)="onFocus()"
            (keydown.enter)="onEnter()"
            paceCoreTextInputRestriction
            class="form-control input-md text-input"
            paceCoreValidationMessage
            [validation]="textInputControl"
            [attr.aria-label]="ariaLabel"
        />
    }
    @if (modelType === 'MultilineTextModel') {
        <textarea
            class="form-control input-md text-input"
            #textAreaInput
            [formControl]="textInputControl"
            [placeholder]="model.options.placeholder"
            (blur)="onBlur()"
            paceCoreTextInputRestriction
            cols="{{ model.options.columns }}"
            rows="{{ model.options.rows }}"
            paceCoreValidationMessage
            [validation]="textInputControl"
            [attr.aria-label]="ariaLabel"
        >
        </textarea>
    }
    @if (modelType === 'InternalInfoMultilineTextModel') {
        <textarea
            class="form-control input-md text-input"
            #internalInfoTextAreaInput
            [formControl]="textInputControl"
            [placeholder]="model.options.placeholder"
            (blur)="onBlur()"
            paceCoreTextInputRestriction
            cols="{{ model.options.columns }}"
            rows="{{ model.options.rows }}"
            paceCoreValidationMessage
            [validation]="textInputControl"
            [attr.aria-label]="ariaLabel"
        >
        </textarea>
    }
    @if (model.options.scannable) {
        <button
            id="scan-btn"
            class="btn btn-secondary"
            [disabled]="model.options.readonly"
            type="button"
            (click)="doScan()"
            [attr.aria-label]="'BARCODE_SCANNER_SET_TITLE' | translate"
        >
            <fa-icon [icon]="faBarcode" size="2x"></fa-icon>
        </button>
    }
    @if (model.options.unit) {
        <div id="unit">
            <span class="input-group-text">{{ model.options.unit }}</span>
        </div>
    }
</div>
